import request from "@/utils/request";

// 获取阈值列表
export function getThresholdList(params) {
  return request.get("/battery/threshold/list", params);
}

// 获取阈值详情
export function getThresholdDetail(id) {
  return request.get(`/battery/threshold/${id}`);
}

// 新增阈值
export function addThreshold(data) {
  return request.post("/battery/threshold/add", data);
}

// 更新阈值
export function updateThreshold(data) {
  return request.post("/battery/threshold/update", data);
}

// 删除阈值
export function deleteThreshold(id) {
  return request.delete(`/battery/threshold/${id}`);
}

// 导出阈值为JSON文件
export function exportThreshold(id, format = "array") {
  return request.get(`/battery/threshold/export/${id}`, { format });
}

// 根据projectId查询阈值
export function getThresholdByProjectId(projectId) {
  return request.get(`/battery/threshold/listByProject?projectId=${projectId}`);
}

export function getOnlineDevicesByProjectId(projectId) {
  return request.get(`/battery/threshold/listDevices?projectId=${projectId}`);
}

export function setThreshold(data) {
  return request.post("/battery/threshold/config", data);
}

// 获取配置结果
export function getThresholdRecord(data) {
  return request.get("/battery/threshold/result", data);
}

// 读取设备阈值
export function readDeviceThreshold(sn) {
  return request.get(`/battery/threshold/read/${sn}`);
}



// WEBPACK FOOTER //
// ./src/store/threshold.js